import React__default from 'react';
import { Typography, Box } from '@mui/material';
import clsx from 'clsx';
import SanitizeHtml from '../../SanitizeHtml/index.js';
import StyledKModalContentSection, { classes } from './index.styled.js';

var KModalContentSection = function (_a) {
    var children = _a.children, id = _a.id, _b = _a.testId, testId = _b === void 0 ? "KModalContentSection" : _b, className = _a.className, title = _a.title, description = _a.description, sx = _a.sx;
    return (React__default.createElement(StyledKModalContentSection, { id: id, "data-testid": testId, className: clsx("KModalContentSection", className), sx: sx },
        !!title && (React__default.createElement(Typography, { className: classes.title, variant: "h5", component: "h1" }, title)),
        !!description && (React__default.createElement(Typography, { className: classes.description, variant: "subtitle1", component: "div" }, typeof description === "string" ? React__default.createElement(SanitizeHtml, { html: description }) : description)),
        !!children && React__default.createElement(Box, null, children)));
};

export { KModalContentSection as default };
//# sourceMappingURL=index.js.map
